import migration1 from './1';

export const CREATE_SEND_PERSIST_VERSION = 1;

export const createSendMigrations = {
  1: migration1,
};
